export default __webpack_public_path__ + "static/media/demo_3.040dbc9e.mp4";